<template>
  <div id="app">
    <UVIndexDaily msg=""/>
  </div>
</template>

<script>
import UVIndexDaily from "../../components/UVIndexDaily";

export default {
  name: 'App',
  components: {
    UVIndexDaily,
  }
}
</script>
